module.exports = __webpack_public_path__ + "static/media/Daario Naharis 1.5d7c6d1f.jpg";